import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './HappinessMeterWidget.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm } from '../../utils';
import { tealiumClickFunc, tealiumGenerateClickData, tealiumMergeClickData } from '../../utils/tealium';
var HappinessMeterWidget = function HappinessMeterWidget(_ref) {
  var formUrl = _ref.formUrl,
    analytics = _ref.analytics,
    customButton = _ref.customButton,
    CTAVariation = _ref.CTAVariation,
    params = _ref.params;
  var _useState = useState({
      visible: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isStickyBannerExist = _useState4[0],
    setIsStickyBannerExist = _useState4[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var btnLabel = getGlobalDictionaryTerm(sitecoreContext, 'happinessMeterLabel') || 'Dubai Happiness Meter';
  var toggleModalVisibility = function toggleModalVisibility() {
    var newState = {
      visible: !modalState.visible
    };
    if (!modalState.ModalComponent) {
      import(/* webpackChunkName: "HappinessMeterWidgetModal" */'./HappinessMeterWidgetModal').then(function (mod) {
        newState.ModalComponent = mod.default;
        setModalState(newState);
      });
    } else {
      setModalState(newState);
    }
  };
  var ModalComponent = modalState.ModalComponent;
  React.useEffect(function () {
    if (canUseDOM) {
      var isExist = !!document.querySelector('.happiness-meter-widget.cta-variation');
      if (isExist) {
        var secondInstance = document.querySelector('.happiness-meter-widget:not(.cta-variation)');
        secondInstance && secondInstance.remove();
      }
    }
  }, [canUseDOM]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    customButton: customButton,
    CTAVariation: CTAVariation
  }, customButton ? /*#__PURE__*/React.createElement("button", {
    className: "m113-sticky-banner-link",
    "data-tooltip-id": "Happiness-Meter-tooltip",
    "aria-label": "Open Happiness Meter",
    onClick: function onClick() {
      if (analytics && analytics['happinessAnalytics']) {
        tealiumClickFunc(tealiumMergeClickData(analytics['happinessAnalytics'], params), 'Happiness Meter');
      }
      toggleModalVisibility();
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: "icon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4327 18.8162C8.16665 18.8162 5.0942 14.8521 4.96551 14.6834L6.85321 13.2434L5.90936 13.9635L6.85163 13.2414C6.87632 13.2733 9.35204 16.4419 12.4327 16.4419H12.4432C14.2137 16.4378 15.9306 15.3617 17.5461 13.2434L19.4338 14.6834C17.3424 17.4258 14.987 18.8162 12.4327 18.8162ZM12 2.37437C6.69241 2.37437 2.37426 6.69256 2.37426 12.0004C2.37426 17.3078 6.69241 21.6256 12 21.6256C17.3077 21.6256 21.6259 17.3078 21.6259 12.0004C21.6259 6.69256 17.3077 2.37437 12 2.37437ZM12 24C5.38324 24 0 18.617 0 12.0004C0 5.38334 5.38324 0 12 0C18.6169 0 24.0001 5.38334 24.0001 12.0004C24.0001 18.617 18.6169 24 12 24Z",
    fill: "currentColor"
  }))) : /*#__PURE__*/React.createElement("button", {
    "aria-label": btnLabel,
    className: "happiness-meter-widget__button",
    onClick: function onClick() {
      if (analytics && analytics.happinessAnalytics) {
        tealiumClickFunc(tealiumGenerateClickData(analytics.happinessAnalytics));
      }
      toggleModalVisibility();
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "rs_skip",
    alt: btnLabel,
    src: "data:image/png;base64,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",
    style: {
      border: '0'
    }
  }))), ModalComponent ? /*#__PURE__*/React.createElement(ModalComponent, {
    analytics: analytics,
    formUrl: formUrl,
    visible: modalState.visible,
    onClose: toggleModalVisibility
  }) : null);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    customButton = _ref2.customButton,
    CTAVariation = _ref2.CTAVariation;
  return /*#__PURE__*/React.createElement("div", {
    className: "happiness-meter-widget ".concat(CTAVariation ? 'cta-variation' : '', " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(customButton ? 'custom-button m113-sticky-banner-card hapiness-meter' : ''),
    "data-cy": "happiness-meter"
  }, children);
};
var commonStyles = "cfnijq5";
var ltrStyles = "l1a46ueu";
var rtlStyles = "r11btpq7";
export default HappinessMeterWidget;